













import { Component, Prop } from 'vue-property-decorator'
import { BaseInput, ICampoTemplate } from './base/BaseInput'

@Component({
  name: 'InputPassword'
})
export default class InputPassword extends BaseInput {
  @Prop({ required: true })
  campo!: ICampoTemplate
}
